// src/components/Home.js
import React from 'react';
import './Home.css';

const Home = ({ isWaiting }) => {
  return (
    <div className="home-container">
      <div className="home-header">
        <h1>Welcome to TeachMeGo</h1>
        <p className="subtitle">Your personalized tutoring dashboard</p>
      </div>

      <div className="home-content">
        <div className="welcome-card">
          <div className="welcome-icon">🎯</div>
          <h2>Get Started</h2>
          <p>
            Ready to start tutoring? Toggle your availability to begin receiving 
            session requests from students.
          </p>
        </div>

        <div className="quick-actions">
          <h3>Quick Actions</h3>
          <div className="actions-grid">
            <div className="action-card">
              <div className="action-icon">📚</div>
              <h4>View Applications</h4>
              <p>Check your tutor applications status</p>
            </div>
            
            <div className="action-card">
              <div className="action-icon">💰</div>
              <h4>Wallet</h4>
              <p>View your earnings and transactions</p>
            </div>
            
            <div className="action-card">
              <div className="action-icon">👤</div>
              <h4>Update Profile</h4>
              <p>Manage your personal information</p>
            </div>
            
            <div className="action-card">
              <div className="action-icon">📅</div>
              <h4>Session History</h4>
              <p>View your past tutoring sessions</p>
            </div>
          </div>
        </div>

        <div className="platform-stats">
          <h3>Platform Overview</h3>
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-value">500+</div>
              <div className="stat-label">Active Tutors</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">2,000+</div>
              <div className="stat-label">Students Helped</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">98%</div>
              <div className="stat-label">Satisfaction Rate</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">5,000+</div>
              <div className="stat-label">Sessions Completed</div>
            </div>
          </div>
        </div>

        <div className="upcoming-sessions">
          <h3>Upcoming Features</h3>
          <ul className="features-list">
            <li>📊 Detailed analytics dashboard</li>
            <li>⭐ Student review system</li>
            <li>🎯 Skill assessment tools</li>
            <li>📱 Mobile app coming soon</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Home;
